import axios from 'axios';
var api_url = "https://api.goodsbill.com";
var app_url = "https://www.goodsbill.com";
var media_url = "https://www.goodsbill.com/media/";
var ga_id = "UA-124179031-1";
export const SITE_NAME = "GoodsBill"
export const APP_VERSION = "3.4.76"
const DEBUG = process.env.NODE_ENV === "development" ? 1 : 0
if(DEBUG) {
  api_url = "http://localhost:8000";
  app_url = "http://localhost:8000";
  media_url = "http://localhost:8000/media/";
  ga_id = "UA-124179031-2";
}
export const GA_ID = ga_id;
Window.app_api_url = api_url;
export const API_BASE_URL = api_url
export const APP_BASE_URL = app_url
export const MEDIA_URL = media_url
export const axi = axios.create({
    baseURL: API_BASE_URL
})

export const INVOICE_LIST_PAGE_SIZE = "invoice_list_page_size"
export const PURCHASE_LIST_PAGE_SIZE = "purchase_list_page_size"
export const RECEIPT_LIST_PAGE_SIZE = "RECEIPT_LIST_PAGE_SIZE"
export const PAYMENT_LIST_PAGE_SIZE = "PAYMENT_LIST_PAGE_SIZE"
export const ITEM_LIST_PAGE_SIZE = "item_list_page_size"
export const CLIENT_LIST_PAGE_SIZE = "client_list_page_size"
export const SUPPLIER_LIST_PAGE_SIZE = "SUPPLIER_LIST_PAGE_SIZE"



// WEBPACK FOOTER //
// ./src/constants.js